// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__3J8ff","forms":"Login_forms__LA5MA"};